<template>
  <header
    class="page-header"
    :class="{ isWebview, 'with-content': hasContent }"
  >
    <div v-if="hasTitle || hasSubtitle || houseNotes" class="page-header-content">
      <house-notes-logo v-if="houseNotes" element="h1" />
      <h1 v-if="hasTitle"><slot /></h1>
      <p v-if="hasSubtitle"><slot name="subtitle" /></p>
    </div>
    <slot name="subnav" />
  </header>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

import { NAV_ROUTES } from '~/constants'
import HouseNotesLogo from '~/components/house-notes-logo'
import UIMixin from '~/mixins/ui'

const { mapGetters: mapEnvironmentGetters } = createNamespacedHelpers('ui/environment')
const { mapGetters: mapProfileGetters } = createNamespacedHelpers('user/profile')

export default {
  mixins: [UIMixin],

  components: {
    HouseNotesLogo
  },

  props: {
    houseNotes: {
      type: Boolean,
      required: false,
      default: false
    },
    simple: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data () {
    return {
      routes: NAV_ROUTES
    }
  },

  computed: {
    ...mapEnvironmentGetters(['isWebview']),
    ...mapProfileGetters(['profile']),
    hasTitle () {
      return Boolean(this.$slots.default)
    },
    hasSubtitle () {
      return Boolean(this.$slots.subtitle)
    },
    hasContent () {
      return this.hasTitle || this.hasSubtitle
    }
  }
}
</script>

<style lang="scss" scoped>

.page-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  background: $color-white;

  &.isWebview {
    padding-top: 0;
  }

  &.with-back-button &:not(.with-content) {
    margin-bottom: $d-x-large;
  }

  .page-header-content {
    width: 100%;
    margin: $space-050 0;

    h1 {
      @include font('090');
      margin: $space-040 0;

      text-align: center;
      width: 100%;
      font-weight: normal;

      @include tablet {
        margin: $space-080 0;
        @include font('100');
      }

      &.house-notes-logo {
        margin: auto;
        width: 320px;
        padding: $d-med-small 0;
        border-top: $line-medium;
        border-bottom: $line-medium;
        @include breakpoint(medium) {
          margin-bottom: $d-med;
        }

        div {
          padding: 0 $d-x-small;
        }
      }

    }

    p {
      margin: $d-x-small;
      text-align: center;
      @include font('040');
    }
  }

  .nav-bar {
    z-index: 10;
    position: fixed;
    top: 0;
  }
}
</style>
